export default __webpack_public_path__ + "static/media/pencil.6531bed9.svg";